<template>
    <section>
        <!--工具条-->
        <el-col :span="24" style="padding-bottom: 0;" size="small">
            <el-form :inline="true" :model="filters" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-autocomplete v-model="filters.name" :fetch-suggestions="querySearch" placeholder="用户名" size="small" :disabled="!this.isUser"></el-autocomplete>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="queryBtn()" size="small" icon="el-icon-search" :disabled="!isAuth('user:list')">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd" size="small" icon="el-icon-plus" :disabled="!isAuth('user:add')">添加用户</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;"
            size="small">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
            <el-table-column prop="account" label="用户名" width="150" align="center"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="180" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="180" align="center"></el-table-column>
            <el-table-column prop="state" label="状态" width="180" align="center">
                <template slot-scope="scope">
                    <el-tag size="medium" type="success" v-if="scope.row.state == 0">正常</el-tag>
                    <el-tag size="medium" type="danger" v-else>禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="roleList" label="角色组" min-width="240" align="center">
                <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper" v-for="item in scope.row.roleList" :key="item.id">
                        <el-tag size="medium">{{ item.role }}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="150" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="text"  @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('user:update')">编辑</el-button>
                    <el-button size="small" type="text" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('user:del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                :total="total" :current-page.sync="page" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" size="small">
                <el-form-item label="用户名" prop="account">
                    <el-input v-model="editForm.account" auto-complete="off" readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="editForm.password" auto-complete="off" type="password"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="editForm.email" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                    <el-input v-model="editForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleList">
                    <el-radio-group v-model="editForm.roleList">
                        <el-radio v-for="(item,index) in roles" :label="index" :key="item.id">{{item.role}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="editForm.state">
                        <el-radio :label="0">正常</el-radio>
                        <el-radio :label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" size="small">
                <el-form-item label="用户名" prop="account">
                    <el-input v-model="addForm.account" auto-complete="off" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="addForm.password" auto-complete="off" type="password"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="addForm.email" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                    <el-input v-model="addForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleList" >
                    <el-radio-group v-model="addForm.roleList">
                        <el-radio v-for="(item,index) in roles" :label="index" :key="item.id">{{item.role}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="addForm.state">
                        <el-radio :label="0">正常</el-radio>
                        <el-radio :label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {
        info,
        getUserList,
        removeUser,
        editUser,
        addUser,
        getRoleList
    } from '../../../api/api';
    import { isAuth } from "../../../utils";

    export default {
        data() {
            return {
                filters: {
                    name: ''
                },
                curUser: '',
                isUser: false,
                users: [],
                userList: [],
                roles: [],
                total: 0,
                page: 0,
                listLoading: false,
                sels: [],
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    email: [
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                    ],
                    mobile: [
                        { validator: 'regexp', pattern: /^\d{11}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    state: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                    roleList: [
                        { required: true, message: '请至少选择一个角色', trigger: 'change' }
                    ]
                },
                //编辑界面数据
                editForm: {
                    account: '',
                    password: '',
                    email: '',
                    mobile: '',
                    state: '',
                    roleList: ''
                },
                editRoleList: [],

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    email: [
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                    ],
                    mobile: [
                        { validator: 'regexp', pattern: /^\d{11}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    state: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                    roleList: [
                        { required: true, message: '请至少选择一个角色', trigger: 'change' }
                    ]
                },
                //新增界面数据
                addForm: {
                    account: '',
                    password: '',
                    email: "",
                    mobile: '',
                    state: 0,
                    roleList: ''
                }

            }
        },
        methods: {
            querySearch(queryString, cb) {
                let users = this.userList;
                let results = queryString ? users.filter(this.createFilter(queryString)) : users;
                cb(results);
            },
            createFilter(queryString) {
                return (user) => {
                    return (user.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getDataList();
            },
            indexMethod(row) {
                return row + (this.page - 1) * 10 + 1
            },
            getUserInfo(u) {
                let para = {account:u}
                this.listLoading = true;
                info(para).then((res) => {
                    if(res.data.code === 0){
                        this.users = [];
                        this.users.push(res.data.info);
                        for(let i = 0;i < 1;i++){
                            let role = [];
                            for(let j = 0; j < this.users[i].roleList.length;j++){
                                role.push(this.users[i].roleList[j].role)
                            }
                            this.users[i].role = role;
                        }
                        this.total = 1;
                    }else {
                        this.$message.error("获取用户列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
          queryBtn(){
            this.page=1;
            this.getDataList();
          },
            //获取用户列表
            getDataList() {
                let para = {
                    page: this.page-1,
                    size: 10,
                    account: this.filters.name
                };
                this.listLoading = true;
                getUserList(para).then((res) => {
                    this.userList = [];
                    if(res.data.code === 0){
                        this.users = res.data.userList.content;
                        for(let i = 0;i < this.users.length;i++){
                            let user = {};
                            user.value = this.users[i].account;
                            this.userList.push(user);

                            let role = [];
                            for(let j = 0; j < this.users[i].roleList.length;j++){
                                role.push(this.users[i].roleList[j].role)
                            }
                            this.users[i].role = role;
                        }
                        this.total = res.data.userList.totalElements;
                    }else {
                        this.$message.error("获取用户列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
            getRoleList(){
                let para = {
                    page: 0,
                    size: 100,
                    role: "",
                };
                getRoleList(para).then((res) => {
                    if(res.data.code === 0){
                        let roleList = res.data.roleList.content;
                        roleList.shift();
                        this.roles = roleList;
                    }else{
                        this.$message.error("获取角色列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    let para = {
                        id: row.id
                    };
                    removeUser(para).then((res) => {
                        if (res.data.code === 0) {
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error("删除失败")
                        }
                        this.listLoading = false;
                        this.getDataList();

                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.editForm.password = '';
                this.roles.forEach((r,index)=>{
                    if(row.roleList[0].id === r.id){ //判断当前用户角色列表中的角色ID是否和全部角色列表中的对应
                        this.editForm.roleList = index; //对应则加入当前角色的数组下标
                    }
                })
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            let roles = [];
                            roles.push(this.roles[this.editForm.roleList]);

                            let para = {
                                id:this.editForm.id,
                                account:this.editForm.account,
                                password: this.editForm.password,
                                mobile: this.editForm.mobile,
                                email: this.editForm.email,
                                state: this.editForm.state,
                                roleList: roles
                            };
                            editUser(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('修改成功');
                                } else {
                                    this.$message.error('修改失败');
                                }
                                this.editLoading = false;
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                if(this.isUser){
                                    this.getDataList();
                                }else{
                                    this.getUserInfo(this.curUser);
                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            let roles = [];
                            roles.push(this.roles[this.addForm.roleList]);
                            let para = {
                                account:this.addForm.account,
                                password: this.addForm.password,
                                mobile: this.addForm.mobile,
                                email: this.addForm.email,
                                state: this.addForm.state,
                                roleList: roles
                            };
                            addUser(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('添加成功');
                                } else {
                                    this.$message.error('添加失败');
                                }
                                this.addLoading = false;
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                if(this.isUser){
                                    this.getDataList();
                                }else{
                                    this.getUserInfo(this.curUser);
                                }
                            });
                        });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            }
        },
        activated() {
            this.curUser = sessionStorage.getItem("username");
            this.isUser = isAuth('user:list');
            if(this.isUser){
                this.getDataList();
            }else{
                this.filters.name = curUser;
                this.getUserInfo(curUser);
            }

            if(isAuth('role:list')){
                this.getRoleList()
            }
        }
    }
</script>

<style scoped>
    .name-wrapper {
        display: inline-block;
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/modules/sys/user.vue